@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<!--Tabs Start-->
<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
  @for (tab of allowedTabs; track tab; let i = $index) {
    <mat-tab >
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon me-1">{{tab.icon}}</mat-icon>
        @if (tab.route !== '.') {
          {{ tab.name | translateAttribute }}
        }
        @if (tab.route === '.') {
          {{ tab.name }}
        }
      </ng-template>
      @if (selectedTabIndex === i) {
        <div class="container-fluid my-2">
          <ng-container>
            <router-outlet></router-outlet>
          </ng-container>
        </div>
      }
    </mat-tab>
  }
</mat-tab-group>
